/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { backpack } from '../../assets/pictograms/Backback';
import { bedroom } from '../../assets/pictograms/Bedroom';
import { blog } from '../../assets/pictograms/Blog';
import { book } from '../../assets/pictograms/Book';
import { calendarCheck } from '../../assets/pictograms/CalendarCheck';
import { calendarDates } from '../../assets/pictograms/CalendarDates';
import { calendarEdit } from '../../assets/pictograms/CalendarEdit';
import { calendarMoney } from '../../assets/pictograms/CalendarMoney';
import { calendarRange } from '../../assets/pictograms/CalendarRange';
import { calendarUser } from '../../assets/pictograms/CalendarUser';
import { caseStudies } from '../../assets/pictograms/CaseStudies';
import { chartDonut } from '../../assets/pictograms/ChartDonut';
import { chartGrowth } from '../../assets/pictograms/ChartGrowth';
import { checkin } from '../../assets/pictograms/Checkin';
import { checklist } from '../../assets/pictograms/Checklist';
import { creditCardChecked } from '../../assets/pictograms/CreditCardChecked';
import { creditCardSecure } from '../../assets/pictograms/CreditCardSecure';
import { direct } from '../../assets/pictograms/Direct';
import { document } from '../../assets/pictograms/Document';
import { globe } from '../../assets/pictograms/Globe';
import { glossary } from '../../assets/pictograms/Glossary';
import { guides } from '../../assets/pictograms/Guides';
import { healthSafety } from '../../assets/pictograms/HealthSafety';
import { heart } from '../../assets/pictograms/Heart';
import { heartBox } from '../../assets/pictograms/HeartBox';
import { journeyManage } from '../../assets/pictograms/JourneyManage';
import { journeyPromote } from '../../assets/pictograms/JourneyPromote';
import { journeyStart } from '../../assets/pictograms/JourneyStart';
import { livingRoom } from '../../assets/pictograms/LivingRoom';
import { luggage } from '../../assets/pictograms/Luggage';
import { manage } from '../../assets/pictograms/Manage';
import { map } from '../../assets/pictograms/Map';
import { messaging } from '../../assets/pictograms/Messaging';
import { mobileCheck } from '../../assets/pictograms/MobileCheck';
import { moneyArrow } from '../../assets/pictograms/MoneyArrow';
import { moneyNote } from '../../assets/pictograms/MoneyNote';
import { nest } from '../../assets/pictograms/Nest';
import { nestShield } from '../../assets/pictograms/NestShield';
import { news } from '../../assets/pictograms/News';
import { noMessages } from '../../assets/pictograms/NoMessages';
import { notification } from '../../assets/pictograms/Notification';
import { onePlatform } from '../../assets/pictograms/OnePlatform';
import { options } from '../../assets/pictograms/Options';
import { password } from '../../assets/pictograms/Password';
import { pdf } from '../../assets/pictograms/Pdf';
import { picture } from '../../assets/pictograms/Picture';
import { promotion } from '../../assets/pictograms/Promotion';
import { propertyAdd } from '../../assets/pictograms/PropertyAdd';
import { propertyApartments } from '../../assets/pictograms/PropertyApartments';
import { propertyCabin } from '../../assets/pictograms/PropertyCabin';
import { propertyGlamping } from '../../assets/pictograms/PropertyGlamping';
import { propertyLakeside } from '../../assets/pictograms/PropertyLakeside';
import { propertyListings } from '../../assets/pictograms/PropertyListings';
import { propertyRemove } from '../../assets/pictograms/PropertyRemove';
import { propertyScore } from '../../assets/pictograms/PropertyScore';
import { propertyVilla } from '../../assets/pictograms/PropertyVilla';
import { question } from '../../assets/pictograms/Question';
import { reviews } from '../../assets/pictograms/Reviews';
import { rucksack } from '../../assets/pictograms/Rucksack';
import { sitemap } from '../../assets/pictograms/Sitemap';
import { smartPricing } from '../../assets/pictograms/SmartPricing';
import { smartPricingAverage } from '../../assets/pictograms/SmartPricingAverage';
import { smartPricingMinimum } from '../../assets/pictograms/SmartPricingMinimum';
import { smartPricingPeak } from '../../assets/pictograms/SmartPricingPeak';
import { star } from '../../assets/pictograms/Star';
import { starBox } from '../../assets/pictograms/StarBox';
import { suitcase } from '../../assets/pictograms/Suitcase';
import { userBasket } from '../../assets/pictograms/UserBasket';
import { userConversation } from '../../assets/pictograms/UserConversation';
import { userDetails } from '../../assets/pictograms/UserDetails';
import { userGroup } from '../../assets/pictograms/UserGroup';
import { userMan } from '../../assets/pictograms/UserMan';
import { userManCircle } from '../../assets/pictograms/UserManCircle';
import { userMoney } from '../../assets/pictograms/UserMoney';
import { userShield } from '../../assets/pictograms/UserShield';
import { userSupport } from '../../assets/pictograms/UserSupport';
import { userWoman } from '../../assets/pictograms/UserWoman';
import { userWomanCircle } from '../../assets/pictograms/UserWomanCircle';
import { video } from '../../assets/pictograms/Video';
import { wordDoc } from '../../assets/pictograms/WordDoc';
export const pictogramLookup = {
    backpack,
    bedroom,
    blog,
    book,
    calendarCheck,
    calendarDates,
    calendarEdit,
    calendarMoney,
    calendarRange,
    calendarUser,
    caseStudies,
    chartDonut,
    chartGrowth,
    checkin,
    checklist,
    creditCardChecked,
    creditCardSecure,
    direct,
    document,
    globe,
    glossary,
    guides,
    healthSafety,
    heart,
    heartBox,
    journeyManage,
    journeyPromote,
    journeyStart,
    livingRoom,
    luggage,
    manage,
    map,
    messaging,
    mobileCheck,
    moneyArrow,
    moneyNote,
    nest,
    nestShield,
    news,
    noMessages,
    notification,
    onePlatform,
    options,
    password,
    pdf,
    picture,
    promotion,
    propertyAdd,
    propertyApartments,
    propertyCabin,
    propertyGlamping,
    propertyLakeside,
    propertyListings,
    propertyRemove,
    propertyScore,
    propertyVilla,
    question,
    reviews,
    rucksack,
    sitemap,
    smartPricing,
    smartPricingAverage,
    smartPricingMinimum,
    smartPricingPeak,
    star,
    starBox,
    suitcase,
    userBasket,
    userConversation,
    userDetails,
    userGroup,
    userMan,
    userManCircle,
    userMoney,
    userShield,
    userSupport,
    userWoman,
    userWomanCircle,
    video,
    wordDoc
};
//# sourceMappingURL=pictogram-lookup.js.map